import { Formik } from "formik";
import React from "react";
import { Form } from "react-bootstrap";
import { Button } from '@blueprint/ui';
import { useHistory } from "react-router-dom";
import * as yup from "yup";

import { FormFooter, InputField } from "../../../common/components/form";
import { FormSubmissionHandler } from "../../../types/common";
import { PageTitle } from "../../../types/pageTitle";

import PublicFormContainer from "./PublicFormContainer";

export type ForgotPasswordFormValues = {
    email: string;
};

const schema: yup.SchemaOf<ForgotPasswordFormValues> = yup.object().shape({
    email: yup.string().required().email("Invalid email address format."),
});

type ForgotPasswordFormProps = {
    onSubmit: FormSubmissionHandler<ForgotPasswordFormValues>;
};

const ForgotPasswordForm = ({
    onSubmit,
}: ForgotPasswordFormProps): JSX.Element => {
    document.title = PageTitle.ForgotPasswordForm;
    const history = useHistory();

    return (
        <PublicFormContainer>
            <h2 className="mb-4">Forgot your Password?</h2>
            <p className="mb-5">
                Please enter your registered email address to receive a password
                reset link.
            </p>
            <Formik
                validationSchema={schema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={onSubmit}
                initialValues={{
                    email: "",
                }}
            >
                {({ handleSubmit, isSubmitting }) => (
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <InputField
                            name="email"
                            label="Email"
                            type="text"
                            autoFocus
                            required={true}
                        />
                        <FormFooter className="d-flex justify-content-between mb-5">
                            <Button
                                onClick={()=> history.push("/login")}
                                disabled={isSubmitting}
                                variant="light.tertiary">Cancel</Button>
                            <Button
                                type="submit"
                                variant="light.primary"
                                style={{marginLeft: '10px'}}
                                disabled={isSubmitting}>Submit</Button>
                        </FormFooter>
                    </Form>
                )}
            </Formik>
        </PublicFormContainer>
    );
};

export default ForgotPasswordForm;
